// extracted by mini-css-extract-plugin
module.exports = {"Chart":"Chart--1u7Qx","Header":"Header--1i-eL","Standalone":"Standalone--15w9J","V2":"V2--3LCjk","Filter":"Filter--3w4V2","Content":"Content--1mnIq"};